/**
 * Navbar scroll class toggle.
 *
 * Hozzáadja a 'scrolled' osztályt a navbar-hoz görgetéskor.
 * Ezzel CSS-ből lehet pl. háttérszínt, shadow-t, méretet változtatni.
 *
 * Használat CSS-ben:
 *   .navbar.scrolled { background: rgba(0,0,0,0.9); box-shadow: ...; }
 */

(function () {
  'use strict';

  var navbar = document.querySelector('.navbar');
  if (!navbar) return;

  var scrollThreshold = 50;
  var ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.scrollY > scrollThreshold) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Initial check (ha az oldal scroll pozícióval töltődik be)
  onScroll();
})();
